import script from "./Carousel-body.vue?vue&type=script&setup=true&lang=js"
export * from "./Carousel-body.vue?vue&type=script&setup=true&lang=js"

import "./Carousel-body.vue?vue&type=style&index=0&id=47f9b14c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f9b14c"]])

export default __exports__